import {Pipe, PipeTransform} from '@angular/core';
import {Functionality} from '../classes/auth/functionality';
import {Feature} from '../classes/auth/feature.class';

@Pipe({
    name: 'functionalityHasFeature'
})
export class FunctionalityHasFeaturePipe implements PipeTransform {

    transform(functionality: Functionality, feature: Feature, ...args: unknown[]): boolean {
        return !!functionality.features?.find(f => f.key === feature.key);
    }

}
